import { render, staticRenderFns } from "./CreateProductsBlock.vue?vue&type=template&id=13619d40&scoped=true"
import script from "./CreateProductsBlock.vue?vue&type=script&lang=js"
export * from "./CreateProductsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13619d40",
  null
  
)

export default component.exports